import axios, { AxiosInstance, AxiosResponse } from 'axios'
import { context } from '.'

var isWaitingForTokenRefresh = false

export const host = process.env.NODE_ENV === 'development' 
    ? "http://127.0.0.1:8003"
    : ""

const createAxiosInstance = (attemptTokenRefresh): AxiosInstance => {

    const axiosInstance = axios.create();
    axiosInstance.defaults.withCredentials = true;
    axiosInstance.defaults.baseURL = host
    axiosInstance.interceptors.request.use(config => {
        // Set Authosization header
        const token = window.localStorage.getItem("aora_questionnaire_jwt")
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    })

    axiosInstance.interceptors.response.use(
        // Argument 1: onFulfilled
        async (response) => {
            return Promise.resolve(response)
        },
        // Argument 1: onRejected
        async (error) => {

            if (attemptTokenRefresh === true && error?.response?.status === 401) {
                
                // If there is already refreshToken request underway, wait for a second and then resolve.
                // This will trigger the original request which should have a valid token by this time.
                if (isWaitingForTokenRefresh === true) {
                    return await new Promise(resolve => setTimeout(resolve, 1000));
                }
                
                try {
                    const uninterceptedAxiosInstance = createAxiosInstance(false)
                    await uninterceptedAxiosInstance.post("/public/refresh-token").then((response) => {
                        context.setToken(response.data.token)
                    })
                    // Resolve the original request as if nothing happened
                    return Promise.resolve(axiosInstance.request(error.response.config))
                } catch {
                    context.setToken(null)
                    return Promise.reject()
                } finally{
                    isWaitingForTokenRefresh = false
                }
            }

            return Promise.reject(error.response)
        }
    )

    return axiosInstance
}


// Define the behaviour for each type of request
// ---------------------------------------------------------------------------------------------
const axiosInstance = createAxiosInstance(true)

const handleResponse = (response: AxiosResponse) => { return Promise.resolve(response) }
const handleResponseBlob = (fileName, blob) => {
    const url = window.URL.createObjectURL(new Blob([blob]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName) //or any other extension
    document.body.appendChild(link)
    link.click()
}

const requests = {
    get: (url: string) =>                               axiosInstance.get(url).then(handleResponse),
    put: (url: string, data: any) =>                    axiosInstance.put(url, data).then(handleResponse),
    post: (url: string, data: any) =>                   axiosInstance.post(url, data).then(handleResponse),
    delete: (url: string) =>                            axiosInstance.delete(url).then(handleResponse),
    fileDownload: (url: string, fileName: string) =>    axiosInstance.get(url, {responseType: 'blob'}).then((response) => handleResponseBlob(fileName, response.data)),
}


export default requests;